import { MODAL } from '../types';

const initialState = {
  showModal: false,
  modalInfo: null,
  reachedLimit: false,
};

const multipleDownloadReducer = (state = initialState, action) => {
  switch (action.type) {
    case MODAL.SWITCH_MULTIPLE_DOWNLOAD_MODAL:
      return {
        ...state,
        showModal: !state.showModal,
        modalInfo: action.payload,
      };

    case MODAL.REACHED_LIMIT_MODAL:
      return {
        ...state,
        reachedLimit: !state.reachedLimit,
      };

    case MODAL.CLOSE_REACHED_LIMIT_MODAL:
      return {
        ...state,
        reachedLimit: false,
      };

    case MODAL.CLOSE_MULTIPLE_DOWNLOAD_MODAL:
      return {
        ...state,
        showModal: false,
        modalInfo: null,
      };

    default:
      return state;
  }
};

export default multipleDownloadReducer;